<template>
  <v-app>
    <drawer></drawer>

    <v-content id="main" :style="{ maxWidth: $store.state.maxWidth }">
      <!-- <v-container fluid> -->
      <router-view></router-view>
      <!-- </v-container> -->
    </v-content>

    <v-dialog
      v-model="dialog"
      persistent
      v-if="dialog.title"
      :max-width="$store.state.maxWidth"
      @keydown.esc="closeDialog('cancel')"
    >
      <v-card id="dialog-card">
        <v-card-title :class="['headline', { 'error--text': dialog.title === 'Error' }]">
          {{ t(dialog.title) }}
        </v-card-title>
        <v-card-text v-html="t(dialog.content)"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-for="button in dialog.buttons"
            :key="button"
            color="primary"
            flat="flat"
            @click="closeDialog(button)"
            >{{ t(button) }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbarVisible" :timeout="timeout" bottom>
      {{ snackbar.message }}
    </v-snackbar>

    <!-- <v-footer app></v-footer> -->
  </v-app>
</template>

<script>
import Drawer from '@/components/layout/Drawer'
import { mapStateMutations } from '@/store'

export default {
  components: { Drawer },
  data() {
    return {
      timeout: 3000,
      mobile: navigator.userAgent.match(
        /Mobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i
      ),
    }
  },
  computed: {
    drawer: mapStateMutations('drawer'),
    snackbarVisible: {
      get() {
        return this.$store.state.snackbar.visible
      },
      set(v) {
        this.$store.commit('snackbarVisible', v)
      }
    },
    snackbar() {
      return this.$store.state.snackbar
    },
    dialog() {
      return this.$store.state.dialog
    },
  },
  methods: {
    closeDialog(action) {
      const handler = this.dialog.handler
      this.$store.commit('dialog', {})
      if (handler) handler(action)
    },
  },
}
</script>

<style lang="stylus">
#app {
  background: white;
  font-size: 16px;
}

#dialog-card {
  .btn {
    min-width: 80px;
  }
}

.content {
  background: white;
}

.container {
  margin: 0px;
}

.card__title {
  span {
    font-weight: 400;
  }
}

.disabled {
  color: rgba(0, 0, 0, 0.38) !important;
}

ul.list hr {
  margin-top: 8px;
}

.list__tile--link:hover, .list__tile--highlighted {
  background: rgba(0, 0, 0, 0.04);
}

.v-text-field input[type=date], .date {
  max-width: 150px;
}

.bold {
  font-weight: bold;
}

.v-menu__content {
  .v-list__tile__action {
    min-width: 40px;
  }
}
</style>
